import type { IconProps } from './types';
import './icons.css';

export default function AlternativeSandWatch({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-alternative-settings ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M10 1.458c.675 0 1.324.087 1.943.231.344.08.6.37.639.72l.132 1.21a1.042 1.042 0 0 0 1.455.84l1.112-.49a.834.834 0 0 1 .943.193 8.529 8.529 0 0 1 1.95 3.362.834.834 0 0 1-.304.913l-.986.723a1.043 1.043 0 0 0 0 1.68l.986.723a.834.834 0 0 1 .304.913 8.527 8.527 0 0 1-1.95 3.362.833.833 0 0 1-.943.193l-1.112-.49a1.042 1.042 0 0 0-1.455.84l-.132 1.21a.833.833 0 0 1-.639.721 8.562 8.562 0 0 1-1.943.23 8.533 8.533 0 0 1-1.943-.23.835.835 0 0 1-.64-.722l-.131-1.209a1.042 1.042 0 0 0-1.455-.84l-1.112.49a.834.834 0 0 1-.943-.193 8.523 8.523 0 0 1-1.95-3.362.833.833 0 0 1 .304-.913l.986-.723a1.042 1.042 0 0 0 0-1.68l-.986-.723a.833.833 0 0 1-.304-.913 8.527 8.527 0 0 1 1.949-3.362.835.835 0 0 1 .944-.193l1.112.49a1.042 1.042 0 0 0 1.455-.841l.132-1.21a.834.834 0 0 1 .64-.72A8.556 8.556 0 0 1 10 1.458Zm0 1.667c-.336 0-.667.026-.993.076l-.065.598A2.71 2.71 0 0 1 5.16 5.984l-.55-.241a6.857 6.857 0 0 0-.997 1.715l.49.358a2.71 2.71 0 0 1-.002 4.368l-.488.359c.248.62.587 1.196.998 1.714l.549-.24A2.708 2.708 0 0 1 8.942 16.2l.065.6a6.63 6.63 0 0 0 1.984 0l.067-.6a2.708 2.708 0 0 1 3.782-2.184l.55.241a6.857 6.857 0 0 0 .996-1.714l-.488-.359a2.708 2.708 0 0 1 0-4.368l.488-.358a6.859 6.859 0 0 0-.997-1.715l-.549.24A2.71 2.71 0 0 1 11.058 3.8l-.066-.598A6.615 6.615 0 0 0 10 3.125Zm0 3.333a3.542 3.542 0 1 1 0 7.085 3.542 3.542 0 0 1 0-7.084Zm0 1.667a1.875 1.875 0 1 0 0 3.751 1.875 1.875 0 0 0 0-3.75Z"
      />
    </svg>
  );
}
